var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 15,
    viewBox: "0 0 30 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_67_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5085 7.03673L22.8131 0.467801C22.7532 0.398601 22.6793 0.342334 22.5961 0.302546C22.5129 0.262758 22.4223 0.240312 22.3298 0.236626C22.2373 0.23294 22.1451 0.248091 22.0589 0.281127C21.9727 0.314162 21.8944 0.364366 21.829 0.428568C21.7635 0.49277 21.7123 0.569576 21.6787 0.654148C21.645 0.73872 21.6296 0.829221 21.6333 0.919941C21.6371 1.01066 21.66 1.09963 21.7005 1.18124C21.7411 1.26286 21.7984 1.33535 21.8689 1.39413L27.4195 6.8465H0.912178C0.739064 6.85297 0.575235 6.92499 0.455088 7.04743C0.334942 7.16988 0.267822 7.33324 0.267822 7.50321C0.267822 7.67318 0.334942 7.83654 0.455088 7.95899C0.575235 8.08143 0.739064 8.15345 0.912178 8.15992H27.4195L21.8689 13.6056C21.7984 13.6644 21.7411 13.7369 21.7005 13.8185C21.66 13.9001 21.6371 13.9891 21.6333 14.0798C21.6296 14.1705 21.645 14.261 21.6787 14.3456C21.7123 14.4302 21.7635 14.507 21.829 14.5712C21.8944 14.6354 21.9727 14.6856 22.0589 14.7186C22.1451 14.7517 22.2373 14.7668 22.3298 14.7631C22.4223 14.7595 22.5129 14.737 22.5961 14.6972C22.6793 14.6574 22.7532 14.6012 22.8131 14.532L29.5085 7.96305C29.6332 7.83993 29.7032 7.67343 29.7032 7.49989C29.7032 7.32634 29.6332 7.15984 29.5085 7.03673Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_67_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow1);
export default __webpack_public_path__ + "static/media/right-arrow 1.922f5489d3b3422df1b91cb24946e952.svg";
export { ForwardRef as ReactComponent };